import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learnanywhere',
  templateUrl: './learnanywhere.component.html',
  styleUrls: ['./learnanywhere.component.scss']
})
export class LearnanywhereComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
